// Shared admin interface strings for states, row actions, dialogs and operation feedback.
export default {
  fa: {
    loading: 'در حال دریافت اطلاعات…',
    retry: 'تلاش دوباره',
    emptyTitle: 'هنوز موردی ثبت نشده است',
    emptyHint: 'با دکمه افزودن، اولین مورد را ثبت کنید.',
    noResultsTitle: 'نتیجه‌ای پیدا نشد',
    noResultsHint: 'عبارت جستجو را تغییر دهید یا فیلترها را پاک کنید.',
    clearSearch: 'پاک کردن جستجو',
    loadErrorTitle: 'اطلاعات دریافت نشد',
    loadErrorHint: 'اتصال برقرار نشد یا سرور پاسخ نداد. دوباره تلاش کنید.',
    forbiddenTitle: 'دسترسی ندارید',
    forbiddenHint: 'برای دیدن این بخش مجوز لازم را ندارید. با مدیر سیستم تماس بگیرید.',
    searchLabel: 'جستجو در فهرست',
    selectedCount: '{count} مورد انتخاب شده',
    selectAllRows: 'انتخاب همه موارد این صفحه',
    selectRow: 'انتخاب این ردیف',
    rowEdit: 'ویرایش',
    rowDelete: 'حذف',
    rowView: 'مشاهده',
    rowChange: 'تغییر',
    newItem: 'افزودن مورد جدید',
    required: 'الزامی',
    close: 'بستن',
    cancel: 'انصراف',
    confirm: 'تایید',
    deleteTitle: 'حذف شود؟',
    deleteMessage: 'این مورد حذف می‌شود. این کار برگشت‌پذیر نیست.',
    deleteGroupTitle: 'حذف {count} مورد؟',
    deleteGroupMessage: '{count} مورد انتخاب‌شده حذف می‌شود. این کار برگشت‌پذیر نیست.',
    deleteConfirm: 'بله، حذف شود',
    unsavedTitle: 'تغییرات ذخیره نشده است',
    unsavedMessage: 'اگر از این صفحه خارج شوید، تغییرات شما از بین می‌رود.',
    leave: 'خروج بدون ذخیره',
    stay: 'ماندن در صفحه',
    saved: 'تغییرات ذخیره شد.',
    deleted: 'مورد حذف شد.',
    pending: 'در حال انجام…',
    mainContent: 'محتوای اصلی',
    breadcrumb: 'مسیر صفحه',
    home: 'خانه',
    openMenu: 'باز کردن منو',
    errors: {
      network: 'پاسخی از سرور نرسید و نتیجه عملیات معلوم نیست. فهرست را بررسی کنید و بعد دوباره تلاش کنید.',
      forbidden: 'اجازه انجام این کار را ندارید.',
      notFound: 'این مورد پیدا نشد. ممکن است قبلا حذف شده باشد.',
      conflict: 'این مورد در این فاصله تغییر کرده است. صفحه را دوباره باز کنید و تغییرات را بررسی کنید.',
      validation: 'اطلاعات واردشده درست نیست. فیلدهای مشخص‌شده را بررسی کنید.',
      server: 'مشکلی در سرور پیش آمد. کمی بعد دوباره تلاش کنید.',
      session: 'نشست شما تمام شده است. دوباره وارد شوید.',
      generic: 'عملیات انجام نشد. دوباره تلاش کنید.',
    },
  },
  en: {
    loading: 'Loading…',
    retry: 'Try again',
    emptyTitle: 'Nothing here yet',
    emptyHint: 'Use the add button to create the first item.',
    noResultsTitle: 'No results found',
    noResultsHint: 'Change the search text or clear the filters.',
    clearSearch: 'Clear search',
    loadErrorTitle: 'Could not load the data',
    loadErrorHint: 'The connection failed or the server did not answer. Try again.',
    forbiddenTitle: 'You do not have access',
    forbiddenHint: 'You do not have permission to see this section. Contact your administrator.',
    searchLabel: 'Search the list',
    selectedCount: '{count} selected',
    selectAllRows: 'Select all items on this page',
    selectRow: 'Select this row',
    rowEdit: 'Edit',
    rowDelete: 'Delete',
    rowView: 'View',
    rowChange: 'Change',
    newItem: 'Add new item',
    required: 'Required',
    close: 'Close',
    cancel: 'Cancel',
    confirm: 'Confirm',
    deleteTitle: 'Delete this item?',
    deleteMessage: 'This item will be deleted. This cannot be undone.',
    deleteGroupTitle: 'Delete {count} items?',
    deleteGroupMessage: 'The {count} selected items will be deleted. This cannot be undone.',
    deleteConfirm: 'Yes, delete',
    unsavedTitle: 'You have unsaved changes',
    unsavedMessage: 'If you leave this page, your changes will be lost.',
    leave: 'Leave without saving',
    stay: 'Stay on page',
    saved: 'Changes saved.',
    deleted: 'Item deleted.',
    pending: 'Working…',
    mainContent: 'Main content',
    breadcrumb: 'Page path',
    home: 'Home',
    openMenu: 'Open menu',
    errors: {
      network: 'The server did not answer, so the result is unknown. Check the list before trying again.',
      forbidden: 'You are not allowed to do this.',
      notFound: 'This item was not found. It may already be deleted.',
      conflict: 'This item changed in the meantime. Reopen the page and review the changes.',
      validation: 'Some of the information is not valid. Check the marked fields.',
      server: 'Something went wrong on the server. Try again in a moment.',
      session: 'Your session has ended. Please sign in again.',
      generic: 'The action was not completed. Try again.',
    },
  },
  ar: {
    loading: 'جارٍ تحميل البيانات…',
    retry: 'حاول مرة أخرى',
    emptyTitle: 'لا توجد عناصر بعد',
    emptyHint: 'استخدم زر الإضافة لإنشاء أول عنصر.',
    noResultsTitle: 'لم يتم العثور على نتائج',
    noResultsHint: 'غيّر نص البحث أو امسح عوامل التصفية.',
    clearSearch: 'مسح البحث',
    loadErrorTitle: 'تعذر تحميل البيانات',
    loadErrorHint: 'فشل الاتصال أو لم يستجب الخادم. حاول مرة أخرى.',
    forbiddenTitle: 'ليس لديك صلاحية',
    forbiddenHint: 'ليست لديك صلاحية لعرض هذا القسم. تواصل مع مدير النظام.',
    searchLabel: 'البحث في القائمة',
    selectedCount: 'تم تحديد {count}',
    selectAllRows: 'تحديد كل عناصر هذه الصفحة',
    selectRow: 'تحديد هذا الصف',
    rowEdit: 'تعديل',
    rowDelete: 'حذف',
    rowView: 'عرض',
    rowChange: 'تغيير',
    newItem: 'إضافة عنصر جديد',
    required: 'مطلوب',
    close: 'إغلاق',
    cancel: 'إلغاء',
    confirm: 'تأكيد',
    deleteTitle: 'هل تريد حذف هذا العنصر؟',
    deleteMessage: 'سيتم حذف هذا العنصر ولا يمكن التراجع عن ذلك.',
    deleteGroupTitle: 'هل تريد حذف {count} عناصر؟',
    deleteGroupMessage: 'سيتم حذف العناصر المحددة ({count}) ولا يمكن التراجع عن ذلك.',
    deleteConfirm: 'نعم، احذف',
    unsavedTitle: 'لديك تغييرات غير محفوظة',
    unsavedMessage: 'إذا غادرت هذه الصفحة فستفقد تغييراتك.',
    leave: 'المغادرة دون حفظ',
    stay: 'البقاء في الصفحة',
    saved: 'تم حفظ التغييرات.',
    deleted: 'تم حذف العنصر.',
    pending: 'جارٍ التنفيذ…',
    mainContent: 'المحتوى الرئيسي',
    breadcrumb: 'مسار الصفحة',
    home: 'الرئيسية',
    openMenu: 'فتح القائمة',
    errors: {
      network: 'لم يصل رد من الخادم، لذلك نتيجة العملية غير معروفة. افحص القائمة قبل المحاولة مرة أخرى.',
      forbidden: 'غير مسموح لك بتنفيذ هذا الإجراء.',
      notFound: 'لم يتم العثور على هذا العنصر. ربما تم حذفه من قبل.',
      conflict: 'تغيّر هذا العنصر في هذه الأثناء. أعد فتح الصفحة وراجع التغييرات.',
      validation: 'بعض المعلومات غير صحيحة. افحص الحقول المحددة.',
      server: 'حدثت مشكلة في الخادم. حاول بعد قليل.',
      session: 'انتهت جلستك. سجّل الدخول من جديد.',
      generic: 'لم يكتمل الإجراء. حاول مرة أخرى.',
    },
  },
}
